import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Dropdown,
  useConfirmation,
  Confirmation,
  Popover,
} from 'freemium-ui';
import { omit } from 'lodash';
import { useFormContext } from 'react-hook-form';

import Icons from 'components/icons';
import Spacer from 'components/Spacer';
import HFDropdown from 'components/hook-form-fields/Dropdown';
import HFToggle from 'components/hook-form-fields/Toggle';

import BlockItemComponent from './block-item-component';
import { OPTION_TYPES } from '../../../constants';
import { Toggle } from 'freemium-ui';
import { Tooltip } from 'freemium-ui';
import { useProductConfigContext } from 'shared/product-config-provider';

export type CustomizeProps = {
  open: boolean;
  block: any;
  blocks: any;
  activeQuestion: any;
  surveyForm: any;
  setSurveyForm: Function;
};

export const Customize = ({
  open,
  surveyForm,
  block,
  blocks,
  setSurveyForm,
  activeQuestion,
}: CustomizeProps) => {
  const { watch, setValue } = useFormContext();
  const productConfig = useProductConfigContext();

  const question = watch('question_details.questions').find(
    (question: any) =>
      question.name ===
      ((block?.question_names && block?.question_names[activeQuestion]) ||
        block?.question_name),
  );

  const nextBlocks = blocks
    .filter((eachBlock: any) => eachBlock.name !== 'TY')
    .slice(
      blocks.findIndex(
        (block: any) =>
          block.question_names?.indexOf(question?.name) > -1 ||
          block.question_name,
      ) + 1,
    );

  const { setVisible, bindings } = useConfirmation(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const allBranchingOptions = [
    // { id: 'next', label: 'Next question' },
    ...(nextBlocks.length > 0
      ? [
          {
            id: 'next',
            label: 'Next question',
            disabled: blocks[blocks.length - 2].name === block.name,
          },
          {
            id: 'specific',
            label: 'Specific question',
            disabled: blocks[blocks.length - 1].name === block.name,
          },
        ]
      : []),
    ...(nextBlocks.length > 0 && block?.type === OPTION_TYPES.DROPDOWN
      ? [{ id: 'logic', label: 'Based on answer' }]
      : []),
    { id: 'end', label: 'End the survey' },
  ];

  // const question = surveyForm?.question_details?.questions?.find(
  //   (question: any) => question.name === block?.question_names[0],
  // );

  const questionIndex = surveyForm?.question_details?.questions?.findIndex(
    (q: any) => q.name === question?.name,
  );

  //sort the blocks other than nps qn,thank you qn & the qns above the currentBlock inclusive
  // let nextBlocks = sortBy(
  //   blocks.filter(
  //     (eachBlock: any) => eachBlock.name !== 'TY' && eachBlock.name !== 'NPS',
  //   ),
  //   'name',
  // );

  // console.log('nextBlocks', nextBlocks);

  // const currentBlockIndex = nextBlocks.findIndex(
  //   (eachBlock: any) => eachBlock.name === block.name,
  // );

  // nextBlocks = nextBlocks.slice(currentBlockIndex + 1);

  // const watchBlock = watch(
  //   `question_details.questions[${questionIndex}].type_info.meta.block`,
  // );

  const resetBlockBranches = () => {
    const questions = watch('question_details.questions');
    setValue(
      `question_details.questions`,
      questions.map((q: any) => {
        if (watchBlock?.question_names?.indexOf(q.name) > -1) {
          return {
            ...q,
            type_info: {
              ...q.type_info,
              meta: { ...omit(q.type_info.meta, ['branches']) },
            },
          };
        }
        return q;
      }),
    );
  };

  const blockQuestionIndex = surveyForm?.question_details?.questions?.findIndex(
    (question: any) => block?.primary_question_name === question.name,
  );

  const watchBlock = watch(
    `question_details.questions[${blockQuestionIndex}].type_info.meta.block`,
  );

  return (
    <StyledStepCustomize>
      {open && (
        <div className="block-actions">
          {surveyForm.state !== 'ACTIVE' && (
            <Button
              type="secondary"
              onClick={() => setVisible(true)}
              style={{
                background: 'transparent',
                border: 'none',
                boxShadow: 'none',
                width: 'auto',
                padding: '2px 5px',
                maxHeight: '27px',
              }}
            >
              <Icons glyph="delete" size="24" viewBox="-6 -4 22 22" />
            </Button>
          )}
          <Spacer x={0.5} />
          <Button
            type="secondary"
            style={{
              background: 'transparent',
              border: 'none',
              boxShadow: 'none',
              width: 'auto',
              padding: '2px 5px',
              maxHeight: '27px',
            }}
            aria-describedby="basic-popover"
            onClick={(e: any) => setAnchorEl(e.currentTarget)}
          >
            <Icons glyph="customize" size="21" viewBox="-2 -3 25 25" />
          </Button>
          <Spacer x={0.2} />
        </div>
      )}
      <Popover
        id="basic-popover"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <StyledStepPopover onClick={(e: any) => e.stopPropagation()}>
          <div className="content">
            <div className="title">Skip Logic</div>
            <Spacer y={0.5} />
            <div className="field">
              <label htmlFor="move-to">Move to</label>
              <Dropdown
                defaultSelectedItem={
                  allBranchingOptions.find(
                    (opt: any) => opt.id === watchBlock?.branchOption,
                  ) || allBranchingOptions[0]
                }
                items={allBranchingOptions}
                itemToString={(item: any) => item.label}
                onChange={(item: any) => {
                  setValue(
                    `question_details.questions[${blockQuestionIndex}].type_info.meta.block.branchOption`,
                    item.id,
                  );

                  if (item.id !== 'logic') {
                    setTimeout(() => {
                      resetBlockBranches();
                    }, 1000);
                  }
                }}
                placeholder="-- --- --"
                disabled={surveyForm.state === 'ACTIVE'}
              />
              {/* 
              <HFDropdown
                name={`question_details.questions[${questionIndex}].type_info.meta.block.branchOption`}
                defaultValue={watchBlock.branchOption}
                items={allBranchingOptions}
                placeholder="-- --- --"
              /> */}

              {/* <Dropdown
                defaultSelectedItem={block.branchOption
                  ? allBranchingOptions.find((opt: any) => opt.id === block.branchOption)
                  : allBranchingOptions[0]}
                items={allBranchingOptions}
                onChange={(item: any) =>
                  item?.id && setBlock('branchOption', item.id)
                }
                itemToString={(item: any) => item.label}
                disabled={false}
                placeholder="-- --- --"
              /> */}
              {watchBlock?.branchOption === 'specific' && (
                <div>
                  <Spacer y={0.5} />
                  <Dropdown
                    defaultSelectedItem={
                      nextBlocks.find(
                        (opt: any) => opt.name === watchBlock.nextBlock,
                      ) || nextBlocks[0]
                    }
                    items={nextBlocks}
                    itemToString={(item: any) =>
                      item.title === 'Thank you' ? 'End Survey' : item.title
                    }
                    onChange={(item: any) => {
                      setValue(
                        `question_details.questions[${blockQuestionIndex}].type_info.meta.block.nextBlock`,
                        item.name,
                      );
                    }}
                    disabled={surveyForm.state === 'ACTIVE'}
                    // disabled={disabled}
                    placeholder="Add follow up questions"
                    itemComponent={(currentBlock: any) => (
                      <BlockItemComponent
                        currentBlock={currentBlock}
                        surveyForm={surveyForm}
                        blocks={blocks}
                      />
                    )}
                  />
                </div>
              )}
            </div>
            <div className="field inline">
              <label htmlFor="required">Answer required</label>
              <Toggle
                hasIcon={false}
                on={watch(
                  `question_details.questions[${blockQuestionIndex}].type_info.meta.block.required`,
                )}
                handleChange={() =>
                  setValue(
                    `question_details.questions[${blockQuestionIndex}].type_info.meta.block.required`,
                    !watch(
                      `question_details.questions[${blockQuestionIndex}].type_info.meta.block.required`,
                    ),
                  )
                }
                disabled={surveyForm.state === 'ACTIVE'}
              />
            </div>
            {((productConfig?.enableAnalyticsPivot &&
              block.type === 'DROPDOWN') ||
              block.type === 'MULTI_SELECT' ||
              block.type === 'PARAGRAPH') && (
              <div className="field inline">
                <label htmlFor="required">
                  <span>
                    Use this answer for analytics&nbsp;
                    <Tooltip
                      label={`Only one ${
                        block.type === 'PARAGRAPH'
                          ? 'long text answer'
                          : 'multichoice answer type'
                      } per survey can be used for analytics`}
                      position="right"
                    >
                      <Icons glyph="info" size={12} viewBox="0 0 16 16" />
                    </Tooltip>
                  </span>
                </label>
                <Toggle
                  disabled={surveyForm.state === 'ACTIVE'}
                  hasIcon={false}
                  on={watch(
                    `question_details.questions[${questionIndex}].type_info.[${
                      block.type === 'DROPDOWN' || block.type === 'MULTI_SELECT'
                        ? 'driver'
                        : 'comment'
                    }`,
                  )}
                  handleChange={() => {
                    const isDriver =
                      block.type === 'DROPDOWN' ||
                      block.type === 'MULTI_SELECT';
                    const isComment = block.type === 'PARAGRAPH';

                    if (
                      watch(
                        `question_details.questions[${questionIndex}].type_info.[${
                          isDriver ? 'driver' : 'comment'
                        }`,
                      )
                    ) {
                      setValue(
                        `question_details.questions`,
                        surveyForm.question_details.questions.map((q: any) => ({
                          ...q,
                          ...(block.question_names.indexOf(q.name) > -1
                            ? {
                                ...q,
                                type_info: {
                                  ...q.type_info,
                                  ...(isDriver
                                    ? { driver: false }
                                    : { comment: false }),
                                },
                              }
                            : {}),
                        })),
                      );
                    } else {
                      //  isDriver && (q.type === 'DROPDOWN' || q.type === "CHECKBOX") => driver: block.question_names.indexOf(q.name) > -1
                      //  isComment && (q.type === 'PARAGRAPH') => comment: block.question_names.indexOf(q.name) > -1
                      const updatedQuestions =
                        surveyForm.question_details.questions.map((q: any) => ({
                          ...q,
                          ...(isDriver &&
                          (q.type_info.question_type === 'DROPDOWN' ||
                            q.type_info.question_type === 'MULTI_SELECT')
                            ? {
                                ...q,
                                type_info: {
                                  ...q.type_info,
                                  driver:
                                    block.question_names.indexOf(q.name) > -1,
                                },
                              }
                            : isComment &&
                              q.type_info.question_type === 'PARAGRAPH'
                            ? {
                                ...q,
                                type_info: {
                                  ...q.type_info,
                                  comment:
                                    block.question_names.indexOf(q.name) > -1,
                                },
                              }
                            : {}),
                        }));

                      setValue(`question_details.questions`, updatedQuestions);
                    }
                  }}
                />
              </div>
            )}
          </div>
        </StyledStepPopover>
      </Popover>
      <Confirmation
        {...bindings}
        title="Delete question"
        cancelButtonText="Cancel"
        onConfirm={() => {
          setSurveyForm({
            ...surveyForm,
            question_details: {
              ...surveyForm.question_details,
              questions: surveyForm.question_details.questions
                .filter((q: any) => block.question_names.indexOf(q.name) === -1)
                .map((q: any, i: number) => {
                  return i === 0
                    ? {
                        ...q,
                        type_info: {
                          ...q.type_info,
                          meta: {
                            ...q.type_info.meta,
                            // reset NPS next block link
                            ...(q.type_info.meta?.block
                              ? {
                                  block: {
                                    ...q.type_info.meta.block,
                                    nextBlock:
                                      q.type_info.meta.block?.nextBlock ===
                                      block.name
                                        ? null
                                        : q.type_info.meta.block?.nextBlock,
                                  },
                                }
                              : {}),
                            // reset NPS branches link
                            ...(q.type_info.meta?.branches
                              ? {
                                  branches: q.type_info.meta?.branches.map(
                                    (a: any) =>
                                      a.nextBlock === block.name
                                        ? { ...a, nextBlock: null }
                                        : a,
                                  ),
                                }
                              : {}),
                          },
                          choices: q.type_info.choices.map((c: any) => {
                            return {
                              ...c,
                              dependent_question_names: [
                                ...(c.dependent_question_names || []).filter(
                                  (dependent_question_name: String) =>
                                    block.question_names.indexOf(
                                      dependent_question_name,
                                    ) === -1,
                                ),
                              ],
                            };
                          }),
                        },
                      }
                    : q.type_info.choices
                    ? {
                        ...q,
                        type_info: {
                          ...q.type_info,
                          meta: {
                            ...q.type_info.meta,
                            ...(q.type_info.meta?.block
                              ? {
                                  block: {
                                    ...q.type_info.meta.block,
                                    nextBlock:
                                      q.type_info.meta.block?.nextBlock ===
                                      block.name
                                        ? null
                                        : q.type_info.meta.block?.nextBlock,
                                  },
                                }
                              : {}),
                          },
                          choices: q.type_info.choices
                            ? q.type_info.choices.map((c: any) => {
                                return {
                                  ...c,
                                  meta: {
                                    ...c.meta,
                                    nextBlock:
                                      c.meta?.nextBlock === block.name
                                        ? null
                                        : c.meta?.nextBlock,
                                  },
                                };
                              })
                            : null,
                        },
                      }
                    : q;
                }),
            },
          });
          setVisible(false);
        }}
        confirmButtonText="Delete"
      >
        Are you sure you want to delete this question?
      </Confirmation>
    </StyledStepCustomize>
  );
};

export default Customize;

const StyledStepCustomize = styled.div`
  .block-actions {
    display: flex;
    align-items: center;
    button:hover {
      background-color: var(--color-smoke-50) !important;
    }
  }
  button {
    padding: 2px 10px;
  }
`;

const StyledStepPopover = styled('div')`
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  margin-top: 10px;

  .title {
    font-weight: 600;
    font-size: 16px;
  }
  .content {
    padding: 15px 20px;

    .field {
      display: block;
      margin: 0 0 30px 0;
      &.inline {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      label {
        font-size: 13px;
        font-weight: 600;
        color: var(--color-smoke-700);
      }

      .icon {
        top: 1px;
        left: 1px;
      }
    }
  }
`;
